import { format } from "date-fns";

const Reportes = ({ data, onClick, onChange, extra }) => {
  return (
    <div className="table-responsive bg-white my-3">
      <table
        className="table table-hover mb-0"
        id="boleteriaVentas"
      >
        <thead className="table-light">
          <tr>
            <th className={`border-0 text-nowrap ${extra ? "" : "d-none"}`}>
              FECHA DE COMPRA
            </th>
            <th className="border-0 text-nowrap">#ID</th>
            <th className="border-0 text-nowrap">COMPRADOR</th>
            <th className={`border-0 text-nowrap ${extra ? "" : "d-none"}`}>
              TELEFONO
            </th>
            <th className={`border-0 text-nowrap ${extra ? "" : "d-none"}`}>
              EMAIL
            </th>
            <th className="border-0 text-nowrap">CODIGO</th>
            <th className={`border-0 text-nowrap ${extra ? "" : "d-none"}`}>
              TIPO
            </th>
            <th className="border-0 text-nowrap">FECHA</th>
            <th className={`border-0 text-nowrap ${extra ? "" : "d-none"}`}>
              MULTIPLICADOR
            </th>
            <th className="border-0 text-nowrap">CANTIDAD</th>
            <th className={`text-end border-0 text-nowrap ${extra ? "" : "d-none"}`}>
              PRECIO
            </th>
            <th className={`text-end  border-0 text-nowrap ${extra ? "" : "d-none"}`}>
              SUBTOTAL
            </th>
            <th className={`border-0 text-nowrap ${extra ? "" : "d-none"}`}>
              DESCUENTO
            </th>
            <th className={`text-end  border-0 text-nowrap ${extra ? "" : "d-none"}`}>
              TOTAL
            </th>
            <th className={`border-0 text-nowrap ${extra ? "" : "d-none"}`}>
              CODIGO DESCUENTO
            </th>
            <th className="border-0 text-nowrap"></th>
            <th className="border-0 text-nowrap">ESTADO</th>
          </tr>
        </thead>
        <tbody>
          {data.data.map((reporte) => {
            if (reporte.reporte_codigo.length > 0) {
              return reporte.reporte_codigo.map((codigo) => {
                return (
                  <tr>
                    <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                      {format(
                        new Date(reporte.created_at),
                        "dd/M/yyyy H:ii:s"
                      ).toString()}
                    </td>
                    <td className="fw-medium text-nowrap">{reporte.id}</td>
                    <td className="text-nowrap">{reporte.nombre_cliente}</td>
                    <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                      {reporte.telefono_cliente}
                    </td>
                    <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                      {reporte.email_cliente}
                    </td>
                    <td className="text-nowrap">{codigo.codigo}</td>
                    <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                      {reporte.entrada.nombre}
                    </td>
                    <td className=" text-nowrap">{reporte.fecha}</td>
                    <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                      {reporte.multiplicador}
                    </td>
                    <td className=" text-nowrap">
                      {reporte.multiplicador
                        ? reporte.multiplicador * codigo.cantidad
                        : codigo.cantidad}
                    </td>
                    <td className={`text-end fw-medium  text-nowrap ${extra ? "" : "d-none"}`}>
                      ${parseFloat(reporte.unidad).toLocaleString("es-AR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className={`text-end fw-medium  text-nowrap ${extra ? "" : "d-none"}`}>
                      ${parseFloat(
                        reporte.unidad * codigo.cantidad
                      ).toLocaleString("es-AR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                      {reporte.descuento ? (
                        <div>
                          ${" "}
                          {parseFloat(
                            ((reporte.unidad * codigo.cantidad) / 100) *
                              reporte.descuento
                          ).toLocaleString("es-AR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </div>
                      ) : (
                        "Sin descuento"
                      )}
                    </td>
                    <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                      {reporte.descuento ? (
                        <div>
                          ${" "}
                          {reporte.unidad * codigo.cantidad -
                            ((reporte.unidad * codigo.cantidad) / 100) *
                              reporte.descuento}
                        </div>
                      ) : (
                        "Sin descuento"
                      )}
                    </td>
                    <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                      {reporte.descuento ? (
                        <div>{reporte.codigo_descuento}</div>
                      ) : (
                        ""
                      )}
                    </td>
                    <td className=" text-nowrap">
                      <label
                        className={`
                        ${
                          codigo.ingreso == "ESPERA"
                            ? "btn btn-outline-secondary fw-bold "
                            : ""
                        }
                        ${
                          codigo.ingreso == "CONCURRIO"
                            ? "btn btn-primary fw-bold"
                            : ""
                        }
                        `}
                      >
                        {codigo.ingreso}
                        <button
                          className="d-none"
                          name="registrar"
                          onClick={(e) =>
                            onClick(e, {
                              ...reporte,
                              registrar:
                                codigo.ingreso == "ESPERA"
                                  ? "CONCURRIO"
                                  : "ESPERA",
                              codigo: codigo.codigo,
                            })
                          }
                        ></button>
                      </label>
                    </td>
                    <td className={`text-nowrap`}>
                      <div>{reporte.status}</div>
                    </td>
                  </tr>
                );
              });
            }
            return (
              <tr>
                <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                  {format(
                    new Date(reporte.created_at),
                    "dd/M/yyyy H:ii:s"
                  ).toString()}
                </td>
                <td className=" text-nowrap">{reporte.id}</td>
                <td className=" text-nowrap">{reporte.nombre_cliente}</td>
                <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                  {reporte.telefono_cliente}
                </td>
                <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                  {reporte.email_cliente}
                </td>
                <td className="text-nowrap">{reporte.codigo}</td>
                <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                  {reporte.entrada.nombre}
                </td>
                <td className=" text-nowrap">{reporte.fecha}</td>
                <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                  {reporte.multiplicador}
                </td>
                <td className=" text-nowrap">
                  {reporte.multiplicador
                    ? reporte.multiplicador * reporte.cantidad
                    : reporte.cantidad}
                </td>
                <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                  {parseFloat(reporte.unidad).toLocaleString("es-AR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                  {parseFloat(reporte.unidad * reporte.cantidad).toLocaleString(
                    "es-AR",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </td>
                <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                  {reporte.descuento ? (
                    <div>
                      ${" "}
                      {parseFloat(
                        ((reporte.unidad * reporte.cantidad) / 100) *
                          reporte.descuento
                      ).toLocaleString("es-AR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </div>
                  ) : (
                    "Sin descuento"
                  )}
                </td>
                <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                  {reporte.descuento ? (
                    <div>
                      ${" "}
                      {reporte.unidad * reporte.cantidad -
                        ((reporte.unidad * reporte.cantidad) / 100) *
                          reporte.descuento}
                    </div>
                  ) : (
                    "Sin descuento"
                  )}
                </td>
                <td className={` text-nowrap ${extra ? "" : "d-none"}`}>
                  {reporte.descuento ? (
                    <div>{reporte.codigo_descuento}</div>
                  ) : (
                    ""
                  )}
                </td>
                <td className=" text-nowrap">
                  <label
                    className={`
                        ${
                          reporte.registro_cliente == "ESPERA"
                            ? "btn btn-outline-secondary fw-bold "
                            : ""
                        }
                        ${
                          reporte.registro_cliente == "CONCURRIO"
                            ? "btn btn-primary fw-bold"
                            : ""
                        }
                        `}
                  >
                    {reporte.registro_cliente}
                    <button
                      className="d-none"
                      name="registrar"
                      onClick={(e) =>
                        onClick(e, {
                          ...reporte,
                          registrar:
                            reporte.registro_cliente == "ESPERA"
                              ? "CONCURRIO"
                              : "ESPERA",
                        })
                      }
                    ></button>
                  </label>
                </td>
                <td className={`text-nowrap`}>
                  <div>{reporte.status}</div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Reportes;
